<template>
    <div class="form-group row">
        <label for="tags" class="col-sm-2 col-form-label">{{label}}<sup v-if='mandatory'>*</sup></label>
        <div class="col-sm-5">
            <multiselect
                v-model="selected"
                :options="options"
                :multiple="true"
                :taggable="true"
                label="product_title"
                track-by="id"
                :searchable="false"
                @input="selectProduct"
                :placeholder="placeholder||'Select Product'"
                class="form-control multi-dropdown select_filter"
                v-bind:disabled="nonEditable ? true : false"
                open-direction="bottom"
            ></multiselect>
        </div>
    </div>
</template>

<script>
    import Multiselect from "vue-multiselect";

    export default {
        name: "DropDownMultiSelect",
        components: { Multiselect },
        data() {
            return {
                selected: [],
                options: []
            };
        },
        props: {
            label: String,
            productVal: Array,
            nonEditable: Boolean,
            mandatory: Boolean,
            placeholder:String
        },
        mounted() {

            this.options = this.$store.state.product.productList;
            if (this.productVal && this.productVal.length) {
				if(!this.productVal[0].product_id){
					let list = []
					this.productVal.map((res) => {
						list.push({product_id:res})
					})
					this.productVal = list;
				}
                let arr = [];
                for (let i = 0; i < this.productVal.length; i++) {
                    for (let j = 0; j < this.options.length; j++) {
                        if (this.productVal[i].product_id == this.options[j].asin) {
                            arr.push(this.options[j]);
							break;
                        }
                    }
                }
                this.selected = arr;
				this.$emit("setSelectedProduct", arr);
            }
        },
        methods: {
            selectProduct(option, id) {

                this.$emit("setSelectedProduct", option);
            }
        }
    };
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css">
    .multiselect__tags {
        border: none !important;
    }
    .multiselect__tag {
        background: teal !important;
    }

</style>
